import axios from "axios";

const fetchHotelGroupsForProgrammes = async (
  token,
  agency = null,
  company = null
) => {
  try {
    const response = await axios.get(
      `${window.API}/api/hotel-groups-for-programmes?${
        agency && !company ? `agency=${agency.value}` : ""
      }${company ? `company=${company.value}` : ""}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {}
};

const removeGroupFromProgramme = async (token, programme, hotelGroup) => {
  try {
    const response = await axios.post(
      `${window.API}/api/preferred-programmes/{id}/remove-group/{hotelGroup}`
        .replace("{id}", programme)
        .replace("{hotelGroup}", hotelGroup),
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {}
};

const setOverridesForProgramme = async (
  token,
  hotelGroup,
  programme,
  values
) => {
  try {
    const response = await axios.post(
      `${window.API}/api/preferred-programmes/{id}/override/{programme}`
        .replace("{id}", hotelGroup)
        .replace("{programme}", programme),
      values,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {}
};

const createGroupForProgramme = async (token, values) => {
  try {
    const response = await axios.post(
      `${window.API}/api/preferred-programmes/custom-group/create/`,
      values,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {}
};
const editGroupForProgramme = async (token, hotelGroup, programme, values) => {
  try {
    const response = await axios.post(
      `${window.API}/api/preferred-programmes/custom-group/{id}/edit/{programme}`
        .replace("{id}", hotelGroup)
        .replace("{programme}", programme),
      values,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {}
};

const checkVenueForPreferredProgramme = async (token, agency, company) => {
  try {
    const response = await axios.get(
      `${window.API}/api/preferred-programmes/is-in-programme/?${
        agency ? `agency=${agency.value ? agency.value : agency}` : ""
      }${company ? `${agency ? '&' : ''}company=${company.value? company.value : company}` : ""}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {}
};

export {
  fetchHotelGroupsForProgrammes,
  removeGroupFromProgramme,
  setOverridesForProgramme,
  createGroupForProgramme,
  editGroupForProgramme,
  checkVenueForPreferredProgramme,
};
